import polyFill from "./polyfills";

export default polyFill;
